import { lazy } from "react";

/* Components */
const Home = lazy(() => import("../components/Home/Home"));
const Login = lazy(() => import("../components/Login/Login"));
export default [
    /* Общи */
    { path: `/`, name: "Home", component: <Home /> },
    { path: `*`, name: "Home", component: <Home /> }
]